export const actions = {
  noRequest: 0,
  pendingRequest: 1,
  start: 2,
  continue: 3,
  review: 4,
  monitoring: 5,
  synchronous: 6,
  error: 999,
}
